import {useSearchParams} from 'react-router-dom';
import {useForm} from 'react-hook-form';
import {FormTextField} from '../../ui/forms/input-field/text-field/text-field';
import {Button} from '../../ui/buttons/button';
import {Form} from '../../ui/forms/form';
import {LoginPayload, useLogin} from '../requests/use-login';
import {FormCheckbox} from '../../ui/forms/toggle/checkbox';

import {AuthLayout} from './auth-layout/auth-layout';
import {Trans} from '../../i18n/trans';
import {StaticPageTitle} from '../../seo/static-page-title';

export function LoginPage() {
    const form = useForm<LoginPayload>({
        defaultValues: {remember: true},
    });
    const login = useLogin(form);

    const heading = <Trans message="Login" />;

    const message = '';

    const isInvalid = !!Object.keys(form.formState.errors).length;

    return (
        <AuthLayout heading={heading} message={message}>
            <StaticPageTitle>
                <Trans message="Login" />
            </StaticPageTitle>
            <Form
                form={form}
                onSubmit={payload => {
                    login.mutate(payload, {
                        onSuccess: response => {
                            //   if (response.two_factor) {
                            //     onTwoFactorChallenge();
                            //   }
                        },
                    });
                }}
            >
                <FormTextField
                    className="mb-5"
                    name="email"
                    type="email"
                    label={<Trans message="Email" />}
                    invalid={isInvalid}
                    required
                />
                <FormTextField
                    className="mb-8"
                    name="password"
                    type="password"
                    label={<Trans message="Password" />}
                    invalid={isInvalid}
                    required
                />
                <FormCheckbox name="remember" className="mb-8 block">
                    <Trans message="Stay signed in for a month" />
                </FormCheckbox>
                <Button
                    className="block w-full"
                    type="submit"
                    variant="flat"
                    color="primary"
                    size="md"
                    disabled={login.isPending}
                >
                    <Trans message="Continue" />
                </Button>
            </Form>
        </AuthLayout>
    );
}
